module.exports = __webpack_public_path__ + "static/media/verified_user_active.eeca50fd.svg";